let facetButton = document.querySelectorAll('.search-facets .btn');
let filterCheckbox = document.querySelectorAll('.filter-list .custom-checkbox-input');
const showListingResults = document.querySelector('.show-listing-results');

facetButton.forEach(item => {
	item.addEventListener('click', event => {
		let facetValue = item.dataset.facet;
		filterCheckbox.forEach(checkbox => {
			let checkboxValue = checkbox.name.toLowerCase();
			if (checkboxValue === facetValue) {
				checkbox.click();
			}
		});
		showListingResults.click();
	});
});
